import { useEffect, useState } from 'react';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from 'components/footers/FiveColumnWithInputForm.js';
import Swal from 'sweetalert2';
import './style.css';
import { useTranslation } from 'react-i18next';

const UserAdmin = () => {
  const { t } = useTranslation();

  const [suppliers, setSuppliers] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deletedSuppliers, setDeletedSuppliers] = useState(new Set());
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    checkAdminStatus();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      fetchAllSuppliers();
    }
  }, [currentPage, isAdmin]);

  const checkAdminStatus = () => {
    const isAdmin = localStorage.getItem('isAdmin') === '1';
    setIsAdmin(isAdmin);
    if (isAdmin) {
      fetchAllSuppliers();
    }
  };

  const fetchAllSuppliers = async () => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return;

      const response = await axios.get(`https://elanciabioapi.com/api/admin/suppliers?page=${currentPage}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        setSuppliers(response.data.data);
        setTotalPages(response.data.last_page);
      }
    } catch (error) {
      console.error('Failed to fetch suppliers:', error);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const banUser = async (supplierId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.delete(
        `https://elanciabioapi.com/api/admin/user/${supplierId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setDeletedSuppliers((prev) => new Set(prev.add(supplierId)));
        Swal.fire('Success', 'Utilisateur supprimé avec succés!', 'success');
        fetchAllSuppliers();
      } else {
        Swal.fire('Error', 'Échec de la suppression', 'error');
      }
    } catch (error) {
      Swal.fire('Error', error.response?.data || 'Something went wrong', 'error');
      fetchAllSuppliers();
    }
  };

  const filteredSuppliers = suppliers.filter((supplier) =>
    supplier.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (!isAdmin) {
    return <p className="text-danger text-center">{t('Unauthorized: You do not have admin access.')}</p>;
  }

  return (
    <AnimationRevealPage>
      <LightAdmin />
      <div className="d-flex flex-column flex-md-row">
        <section className="w-100 p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h1 className="text-dark display-4">{t('Tableau_de_bord_Utilisateurs')}</h1>
            <input
              type="text"
              className="form-control w-25"
              placeholder={t('Rechercher_par_nom')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <hr className="my-4" />

          <div className="table-responsive">
            <table className="table table-striped table-hover">
              <thead className="table-primary">
                <tr>
                  <th>{t('Identifiant')}</th>
                  <th>{t('Nom')}</th>
                  <th>{t('Email')}</th>
                  <th>{t('Numéro_de_Téléphone')}</th>
                  <th>{t('Adresse')}</th>
                  <th>{t('Role')}</th>
                  <th>{t('Actions')}</th>
                </tr>
              </thead>
              <tbody>
                {filteredSuppliers.length > 0 ? (
                  filteredSuppliers.map((supplier) => (
                    <tr key={supplier.id}>
                      <td>{supplier.custom_id}</td>
                      <td>{supplier.name}</td>
                      <td>{supplier.email}</td>
                      <td>{supplier.phone}</td>
                      <td>{supplier.address}</td>
<td>
    {supplier.role === 'supplier' ? 'Distributeur' : supplier.role ?? 'Aucun rôle'}
</td>                       <td>
                        <button
                          className="btn btn-danger"
                          style={{ backgroundColor: '#336734' }}
                          onClick={() => banUser(supplier.id)}
                          disabled={supplier.is_deleted}
                        >
                          {t('BAN')}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">{t('Aucun utilisateur trouvé')}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-center">
            <nav>
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>
                    {t('Previous')}
                  </button>
                </li>
                {[...Array(totalPages)].map((_, index) => (
                  <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                      {index + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>
                    {t('Next')}
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </section>
      </div>
      <Footer />
    </AnimationRevealPage>
  );
};

export default UserAdmin;
